export default {"src":"/_next/static/media/isPlayingProgram.4a9239dc.svg","height":12,"width":26,"blurWidth":0,"blurHeight":0};